import React from 'react';
import { Dialog } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}

/**
 * Általános dialógus. Headless UI Dialog: Esc-re és a háttérre kattintva bezárul,
 * a fókusz benne marad, a képernyőolvasó dialógusként (címmel) jelenti be.
 */
const Modal: React.FC<ModalProps> = ({ isOpen, onClose, title, children }) => {
  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" />

      <div className="fixed inset-0 z-50 overflow-y-auto">
        <div className="flex min-h-full items-stretch justify-center md:items-center md:p-4">
          {/* Mobilon teljes képernyős, alulról beúszó panel; md-től középre igazított dialógus */}
          <Dialog.Panel className="modal-panel-mobile relative flex w-full flex-col overflow-hidden bg-white shadow-xl md:max-w-md md:rounded-lg">
            <div className="flex shrink-0 items-center justify-between border-b border-gray-200 px-4 py-3 md:border-0 md:px-6 md:pb-0 md:pt-4">
              <Dialog.Title as="h3" className="text-lg font-semibold text-gray-900">
                {title}
              </Dialog.Title>
              <button
                type="button"
                onClick={onClose}
                aria-label="Bezárás"
                className="flex h-9 w-9 items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none transition-colors"
              >
                <XMarkIcon className="h-6 w-6" />
              </button>
            </div>

            <div className="flex-1 px-4 pt-4 pb-safe-4 md:px-6">
              {children}
            </div>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
};

export default Modal;
